const TargetMap: { [key: number]: string } = {
    1: "特店",
    2: "銀行",
    3: "全部",
  };
  
  export const Announcement = {
    TargetMap,
  };
  